module.exports = __webpack_public_path__ + "static/media/presse-pantalon.10053497.svg";